import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "../css/Partners.css";

// PARTNER IMAGES


import partner1 from "../../media/images/Story/Good.png";
import partner2 from "../../media/images/Story/ltv1.png";
import partner3 from "../../media/images/Story/Sali.png";
import partner4 from "../../media/images/Story/WHI.png";
import partner5 from "../../media/images/Story/bombo2.png";

const Partners = () => {

  const partners = [
    {
      name: "Sali International Hospital",
      image: partner3,
      website: "https://www.salihospital.com",
      words: "Providing excellent healthcare services with compassion and professionalism.",
    },
    {
      name: "Women's Hospital ",
      image: partner4,
      website: "https://www.womenshospitalinternational.com",
      words: "Dedicated to women's health, fertility care, and family wellness.",
    },
    {
      name: "Lighthouse Television",
      image: partner2,
      website: "https://www.lighthousetv.co.ug",
      words: "Sharing inspiring stories, faith, and impactful media across Uganda.",
    },
    {
      name: "Goodnews Paper",
      image: partner1,
      website: "https://www.goodnewspaper.co.ug",
      words: "Delivering trusted news, hope, and community updates.",
    },
    {
      name: "Bombo Resort",
      image: partner5,
      website: "https://bomborestaurantandresort.com",
      words: "Offering comfort, relaxation, and memorable hospitality experiences.",
    },
  ];

  return (
    <div className="partners-section py-5">

      <div className="container">

        <div className="text-center mb-5">
          <h2 className="partners-title" data-aos="fade-up">
            Our Partners
          </h2>

          <p className="partners-subtitle" data-aos="fade-up">
            We proudly work with trusted organizations and brands that share our vision of excellence.
          </p>
        </div>

        <Swiper
  modules={[Autoplay, Pagination]}
  spaceBetween={30}

  // SHOW 2
  slidesPerView={3}

  // MOVE 1 BY 1
  slidesPerGroup={1}

  loop={true}
  speed={1400} // 🧠 smooth transition (not too fast)

  autoplay={{
    delay: 4500, // ⏳ gives breathing space
    disableOnInteraction: false,
  }}

  

  pagination={{
    clickable: true,
  }}

  breakpoints={{
    0: {
      slidesPerView: 1,
    },

    768: {
      slidesPerView: 2,
    },

    992: {
      slidesPerView: 3,
    },
  }}
>
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <div className="partner-card text-center">
                <img src={partner.image} alt={partner.name} className="img-fluid mb-3" />
                <h3 className="partner-name">{partner.name}</h3>
                <p className="partner-description">{partner.words}</p>
                <a href={partner.website} target="_blank" rel="noopener noreferrer" className="btn btn-primary vistwebsite-btn">
                  Visit Website
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Partners;